// extracted by mini-css-extract-plugin
export default {"actions":"Project_actions__OX2Yq","fileSection":"Project_fileSection__8S08D","preview":"Project_preview__3-O8b"};